<!-- <div class="gradiant-top">
<div class="container container-icon h-100 text-center">
<div class="icons-row">
<div class="col-centered">
<div class="device active">
<div class="img-container d-flex align-items-center justify-content-center">
<img class="img-cliquer h-100" src="assets/download_page/webgl.png">
</div>
<span class="logo-subtitle">{{"Essai gratuit en ligne" | translate}}</span>
<app-svg-icon [src]="'assets/svg/chevron-down-solid.svg'" [size]="'20px'"></app-svg-icon>
</div>
</div>
<div class="col-centered">
<div class="device" [routerLink]="language.navigateAccordingToLang(['/downloads'])">
<div class="img-container d-flex align-items-center justify-content-center">
<img class="img-cliquer h-100" src="assets/download_page/downloadwhite.png">
</div>
<span class="logo-subtitle">{{"Télécharger la version complète" | translate}}</span>
<app-svg-icon [src]="'assets/svg/chevron-down-solid.svg'" [size]="'20px'"></app-svg-icon>
</div>
</div>
</div>
</div>
</div> -->

<div class="container py-5">
  <div class="row row-min justify-content-around d-flex">
    <div class="col-12">
      <div class="row d-flex justify-content-md-end justify-content-center top-buttons align-items-center mb-4" >
        <a class="btn btn-green" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" title="contact"><i class="fas fa-envelope mr-2"></i>{{'Nous contacter' | translate}}</a>
        <a class="btn share-button" id="shareBtn" (click)="shareButton()" [ngClass]="{'hideShare': btnIsVisible === false}">
          <i class="fas fa-share-alt mr-1"></i>
          {{"Partager" | translate}}
        </a>
        <div class="social-share" id="socialBtn" [ngClass]="{'showSocial': showSocialBtn === true, 'hidden' : showSocialBtn === false }">
          <a class="facebook" title="Facebook" target="_blank" rel="noopener nofollow" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fimmersivefactory.com%2Ffr%2Fdemo" title="facebook"><i class="fa fa-facebook"></i></a>
          <a class="twitter" title="Twitter" target="_blank" rel="noopener nofollow" href="{{twitterUrl}}" title="twitter"><i class="fa fa-twitter"></i></a>
          <a class="linkedin" title="LinkedIn" target="_blank" rel="noopener nofollow" href="http://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fimmersivefactory.com%2Ffr%2Fdemo&title=" title="linkedin"><i class="fa fa-linkedin"></i></a>
        </div>
        <a (click)="clickOnLikeBtn()" [ngClass]="{'liked' : userAlredyLike }" title="Like" class="btn btn-counter"><i class="fas fa-thumbs-up mr-1"></i> {{"Like" | translate}}</a><span class="chiffre">{{staticLikeNumber + likeNumber}}</span>
      </div>
    </div>
    <div class="col-12 col-md-4 d-flex flex-column mb-md-0 mb-4 text-md-left text-center">
      <div class="">
        <h1 class="title">{{"Extrait gratuit en ligne" | translate}}</h1>
        <p class="h-custom mt-4 mb-3">{{"Dans quelques instants, découvrez l'exercice chasse aux risques entrepôt." | translate}}</p>
        <p class="h-custom mb-3">{{"Devenez acteur de votre formation, pour un objectif zéro accident !" | translate}}</p>
        <p class="h-custom mb-3">{{"Cliquez sur l’image à droite pour commencer :" | translate}}</p>
      </div>
      <div class="grey-border mt-2">
        <div class="controls-title text-center py-2">
          {{"Contrôles" | translate}}
        </div>
        <div class="game-controls p-4">
          <div class="game-control m-auto m-md-0">
            <div class="icon">
              <app-svg-icon [src]="'assets/svg/left-click.svg'" [size]="'35px'"></app-svg-icon>
            </div>
            {{"Se déplacer" | translate}}
          </div>
          <div class="game-control m-auto m-md-0">
            <div class="icon">
              <app-svg-icon [src]="'assets/svg/right-click.svg'" [size]="'35px'"></app-svg-icon>
            </div>
            {{"Corriger l’anomalie" | translate}}
          </div>
          <div class="game-control m-auto m-md-0" *ngIf="pointerLocked">
            <div class="icon">
              <app-svg-icon [src]="'assets/svg/f-key.svg'" [size]="'30px'"></app-svg-icon>
            </div>
            {{"Plein écran" | translate}}
          </div>
          <div class="game-control m-auto m-md-0" *ngIf="pointerLocked">
            <div class="icon">
              <app-svg-icon [src]="'assets/svg/esc-key.svg'" [size]="'30px'"></app-svg-icon>
            </div>
            {{"Reprendre le contrôle de la souris" | translate}}
          </div>
        </div>
      </div>

    </div>
    <div class="col-12 col-md-8">
      <div class="container pr-0">
        <div id="app-container">
          <webgl-build
          #webGLBuild
          *ngIf="showApp"
          (changeMouseStatus) = "changeMouseStatus($event)"
          (eventEmit) = "buildEvent($event)"
          overlayImg = "/assets/demo_webgl.jpg"
          overlayText = "<span class='h1'>{{'A vous de jouer !' | translate}}</span>"
          appUrl = "/assets/frames/webgl_demo.html"
          loadingText = "<div class='p-3 h4 text-center'><p>{{'Dans quelques instants, découvrez un extrait de l’exercice chasse aux risques entrepôt...' | translate}}</p><p class='mb-0'>{{'Devenez acteur de votre formation, pour un objectif zéro accident !' | translate}}</p></div>"
          ></webgl-build>
          <div id="textPostBuild" *ngIf="displayEndText">
            <div class="d-flex flex-column items-center justify-content-center">
              <div class="game-buttons d-flex mt-2">
                <button class="btn btn-action btn-yellow" (click)="replay()">
                  <i class="fas fa-undo"></i>
                  {{"Rejouer" | translate}}
                </button>
              </div>
              <h4 class="m-0">{{"Votre opinion nous importe !" | translate}}</h4>
              <div class="game-buttons d-flex">
                <a class="btn btn-action" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" title="contact">
                  {{"Contactez-nous" | translate}}
                </a>
              </div>
            </div>
          </div>
          <!-- <div class="catalogButton">
          <a class="test-more-btn my-4" [routerLink]="language.navigateAccordingToLang(['/content'])" [queryParams]="{tags: 2}" title="full version">{{'Essayez une version complète' | translate }}</a>
        </div> -->
      </div>
    </div>
  </div>
  <div class="col-12 mt-4 mt-lg-5">

    <div class="row">
      <div class="col-12 py-0 position-relative">
        <div class="p-5 banner-catalog d-flex flex-column flex-lg-row justify-content-lg-between align-items-center radius-10">
          <div class="text-lg-left text-center mw-custom mb-lg-0 mb-4">
            <h2 class="h-custom title-banner text-immersive">{{'Envie de plus d’immersion ?' | translate}}</h2>
            <p class="h-custom font-weight-light mb-0 pb-0">{{'La version complète I-Learning est disponible sur abonnement annuel. Et pour plus d’immersion, lancez-vous en réalité virtuelle !' | translate}}</p>
          </div>
          <div class="text-center">
            <button class="btn btn-blue btn-rounded py-3 px-4 shadow-custom" [routerLink]="language.navigateAccordingToLang(['/subscription'])" [queryParams]="{src: 'demo'}" title="subscribe"><i class="fas fa-sign-in-alt mr-2"></i>{{'S’abonner à la version complète' | translate}}</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
</div>

<app-iframe-gratitude *ngIf="gratitudes['startPlay']" iframeurl="/gratitude/webgl_start.html" (iframeLoaded)="iframeLoaded('startPlay')"></app-iframe-gratitude>
<app-iframe-gratitude *ngIf="gratitudes['endPlay']" iframeurl="/gratitude/webgl_end.html" (iframeLoaded)="iframeLoaded('endPlay')"></app-iframe-gratitude>

<app-iframe-gratitude *ngIf="gratitudes['replay']" iframeurl="/gratitude/event.html?webgl-replay" (iframeLoaded)="iframeLoaded('replay')"></app-iframe-gratitude>
<app-iframe-gratitude *ngIf="gratitudes['share']" iframeurl="/gratitude/event.html?webgl-share" (iframeLoaded)="iframeLoaded('share')"></app-iframe-gratitude>
